import { CSSResultGroup, html, css, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import componentStyles from './ghs-review-card.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

import '../ghs-rate/ghs-rate';

/**
 * The ghs-review-card component.
 * @element ghs-review-card
 */
@customElement('ghs-review-card')
export class GhsReviewCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, css``];

  /**
   * Rating value.
   */
  @property({ type: Number }) rating = 0;

  /**
   * Label text.
   */
  @property({ type: String }) label: string;

  render(): TemplateResult {
    const rounded = Math.round(this.rating * 10) / 10;

    return html`
      <div class="review-card">
        <div class="review-card__label">${this.label}</div>
        <div class="review-card__content">
          <div class="review-card__rate">${rounded}</div>
          <ghs-rate
            value=${rounded}
            icon-size="26"
            site=${this.site}
          ></ghs-rate>
        </div>
      </div>
    `;
  }
}
